export const getShotPath = (path: string) => path.split('/').pop();
